import { render, staticRenderFns } from "./IconCapsLock.vue?vue&type=template&id=6aad54fa&"
import script from "./IconCapsLock.vue?vue&type=script&lang=js&"
export * from "./IconCapsLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports